import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button } from 'reactstrap';

const TemplateDetailsModal = ({ template, onClose }) => {
  if (!template) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label="Close modal backdrop"
    >
      <div
        style={{
          background: 'white',
          borderRadius: '8px',
          width: '90%',
          maxWidth: '800px',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        }}
        aria-labelledby="modal-title"
      >
        <div
          style={{
            padding: '20px',
            borderBottom: '2px solid #e0e0e0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'sticky',
            top: 0,
            background: 'white',
            zIndex: 1,
          }}
        >
          <h3
            id="modal-title"
            style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}
          >
            Template Details: {template.name}
          </h3>
          <Button
            color="link"
            onClick={onClose}
            style={{
              fontSize: '24px',
              color: '#666',
              padding: '0 8px',
              textDecoration: 'none',
            }}
            aria-label="Close modal"
          >
            ×
          </Button>
        </div>

        <div style={{ padding: '20px' }}>
          {/* Template Info */}
          <div
            style={{
              background: '#f8f9fa',
              padding: '15px',
              borderRadius: '6px',
              marginBottom: '20px',
            }}
          >
            <h4 style={{ margin: '0 0 10px 0', fontSize: '15px' }}>
              Template Information
            </h4>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '10px',
                fontSize: '13px',
              }}
            >
              <div>
                <strong>Template ID:</strong> {template.id}
              </div>
              <div>
                <strong>Status:</strong> {template.status}
              </div>
              <div>
                <strong>Category:</strong> {template.category}
              </div>
              <div>
                <strong>Language:</strong> {template.language}
              </div>
            </div>
          </div>

          {/* Full Message Text */}
          <div
            style={{
              background: '#e3f2fd',
              padding: '15px',
              borderRadius: '6px',
              marginBottom: '20px',
            }}
          >
            <h4 style={{ margin: '0 0 10px 0', fontSize: '15px' }}>
              Full Message
            </h4>
            <div
              style={{
                fontSize: '13px',
                lineHeight: '1.6',
                whiteSpace: 'pre-wrap',
                maxHeight: '200px',
                overflowY: 'auto',
                padding: '10px',
                background: 'white',
                borderRadius: '4px',
                border: '1px solid #dee2e6',
              }}
            >
              {template.title}
            </div>
          </div>

          {/* Analytics Summary */}
          <div
            style={{
              background: '#f1f3f5',
              padding: '15px',
              borderRadius: '6px',
              marginBottom: '20px',
            }}
          >
            <h4 style={{ margin: '0 0 15px 0', fontSize: '15px' }}>
              Analytics Summary
            </h4>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                gap: '15px',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    color: '#1565c0',
                  }}
                >
                  {template.count.toLocaleString()}
                </div>
                <div
                  style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}
                >
                  Sent
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    color: '#2e7d32',
                  }}
                >
                  {template.delivered.toLocaleString()}
                </div>
                <div
                  style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}
                >
                  Delivered
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    color: '#ef6c00',
                  }}
                >
                  {template.read.toLocaleString()}
                </div>
                <div
                  style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}
                >
                  Read
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    color: '#7b1fa2',
                  }}
                >
                  ₹{(template.totalCost || 0).toFixed(2)}
                </div>
                <div
                  style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}
                >
                  Total Cost
                </div>
              </div>
            </div>
          </div>

          {/* Daily Analytics */}
          {template.analytics && template.analytics.length > 0 && (
            <div>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '15px' }}>
                Daily Analytics
              </h4>
              <div style={{ overflowX: 'auto' }}>
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: '12px',
                  }}
                >
                  <thead>
                    <tr style={{ background: '#f1f3f5' }}>
                      <th
                        style={{
                          padding: '10px',
                          textAlign: 'left',
                          fontWeight: 600,
                        }}
                        scope="col"
                      >
                        Date
                      </th>
                      <th
                        style={{
                          padding: '10px',
                          textAlign: 'right',
                          fontWeight: 600,
                        }}
                        scope="col"
                      >
                        Sent
                      </th>
                      <th
                        style={{
                          padding: '10px',
                          textAlign: 'right',
                          fontWeight: 600,
                        }}
                        scope="col"
                      >
                        Delivered
                      </th>
                      <th
                        style={{
                          padding: '10px',
                          textAlign: 'right',
                          fontWeight: 600,
                        }}
                        scope="col"
                      >
                        Read
                      </th>
                      <th
                        style={{
                          padding: '10px',
                          textAlign: 'right',
                          fontWeight: 600,
                        }}
                        scope="col"
                      >
                        Cost
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {template.analytics.map((point, idx) => {
                      const uniqueKey = `${template.id}-${point.start}-${idx}`;
                      return (
                        <tr
                          key={uniqueKey}
                          style={{
                            borderBottom: '1px solid #e9ecef',
                            background: idx % 2 === 0 ? '#fff' : '#fafafa',
                          }}
                        >
                          <td style={{ padding: '10px' }}>
                            {moment.unix(point.start).format('DD MMM YYYY')}
                          </td>
                          <td style={{ padding: '10px', textAlign: 'right' }}>
                            {(point.sent || 0).toLocaleString()}
                          </td>
                          <td style={{ padding: '10px', textAlign: 'right' }}>
                            {(point.delivered || 0).toLocaleString()}
                          </td>
                          <td style={{ padding: '10px', textAlign: 'right' }}>
                            {(point.read || 0).toLocaleString()}
                          </td>
                          <td style={{ padding: '10px', textAlign: 'right' }}>
                            ₹
                            {(
                              point.cost?.find((c) => c.type === 'amount_spent')
                                ?.value || 0
                            ).toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {(!template.analytics || template.analytics.length === 0) && (
            <div
              style={{
                textAlign: 'center',
                padding: '30px',
                background: '#f8f9fa',
                borderRadius: '6px',
                color: '#666',
              }}
            >
              No daily analytics data available for this template
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

TemplateDetailsModal.propTypes = {
  template: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    delivered: PropTypes.number.isRequired,
    read: PropTypes.number.isRequired,
    totalCost: PropTypes.number.isRequired,
    analytics: PropTypes.arrayOf(
      PropTypes.shape({
        start: PropTypes.number,
        sent: PropTypes.number,
        delivered: PropTypes.number,
        read: PropTypes.number,
        cost: PropTypes.arrayOf(
          PropTypes.shape({
            type: PropTypes.string,
            value: PropTypes.number,
          }),
        ),
      }),
    ),
  }),
  onClose: PropTypes.func.isRequired,
};

TemplateDetailsModal.defaultProps = {
  template: null,
};

export default TemplateDetailsModal;
